import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthCookieManagerService implements AbstractSecurityStorage {

  constructor(private cookieService: CookieService) { }

  read(key: string) {
    const item = this.cookieService.get(key);
    if (!!item) {return JSON.parse(item);}
    else {return null;}
  }

  write(key: string, value: any, isSiletTokenRenew = false) {
    value = value || null;
    const cookieExpireInfo = this.read(key);
    let cookieExpiryTime: any;
    if (cookieExpireInfo && !isSiletTokenRenew) {
      const date = new Date(cookieExpireInfo.cookie_expiry_time);
      cookieExpiryTime = new Date(date.getTime());
    } else {
      const date = new Date();
      cookieExpiryTime = new Date(date.getTime() + value.expires_in * 1000);
    }
    const cookieInfo = {
      access_token: value.access_token,
      cookie_expiry_time: cookieExpiryTime
    };
    this.cookieService.set(`${key}`, JSON.stringify(cookieInfo), cookieExpiryTime, undefined, undefined, true, 'Strict');
    return true;
  }

  /**
   * Check if token is expiring soon (within 10 minutes)
   * @param key - Cookie key to check
   * @returns boolean indicating if token needs refresh
   */
  public isTokenExpiringSoon(key: string): boolean {
    const cookieInfo = this.read(key);
    if (!cookieInfo || !cookieInfo.cookie_expiry_time) {
      return true; // Consider expired if no expiry time
    }

    const expiryTime = new Date(cookieInfo.cookie_expiry_time);
    const currentTime = new Date();
    const tenMinutesFromNow = new Date(currentTime.getTime() + (10 * 60 * 1000));

    return expiryTime <= tenMinutesFromNow;
  }

  /**
   * Get token expiry time
   * @param key - Cookie key
   * @returns Date object of expiry time or null
   */
  public getTokenExpiryTime(key: string): Date | null {
    const cookieInfo = this.read(key);
    if (!cookieInfo || !cookieInfo.cookie_expiry_time) {
      return null;
    }
    return new Date(cookieInfo.cookie_expiry_time);
  }

  /**
   * Update token with new expiry time
   * @param key - Cookie key
   * @param newToken - New token value
   * @param expiresIn - Expiry time in seconds
   */
  public updateToken(key: string, newToken: string, expiresIn: number): boolean {
    const date = new Date();
    const cookieExpiryTime = new Date(date.getTime() + expiresIn * 1000);
    
    const cookieInfo = {
      access_token: newToken,
      cookie_expiry_time: cookieExpiryTime
    };
    
    this.cookieService.set(`${key}`, JSON.stringify(cookieInfo), cookieExpiryTime, undefined, undefined, true, 'Strict');
    return true;
  }

  remove(key): void {
    this.cookieService.delete(key);
  }

  clear(): void {
    this.cookieService.deleteAll();
  }

}
